class HappyEmailPopup extends HTMLElement {
  constructor() {
    super();
    this.popup = null; // Reference to the popup element
    this.happyContent = null; // Reference to the happy content
    this.notHappyContent = null; // Reference to the not happy content
  }

  connectedCallback() {
    this.initPopup();
    this.handleCorrectParams();
  }

  initPopup() {
    this.popup = this.querySelector('.happy-email-popup');
    if (!this.popup) return;
    this.happyContent = this.popup.querySelector('[data-happy]');
    this.notHappyContent = this.popup.querySelector('[data-not-happy]');


    // Attach event listener for the "Shop now" button
    this.popup.querySelectorAll('[data-close-popup]').forEach((button) => {
      button.addEventListener('click', this.closePopup.bind(this));
    });

    // Attach event listener for the "Close" if clicked outside the popup
    this.popup.addEventListener('click', (event) => {
      if (event.target === this.popup) {
        this.closePopup();
      }
    });
  }

  handleCorrectParams() {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.size === 0) return

    if (!urlParams.has('order_id') || !urlParams.has('selectedOpt')) return

    void this.sendParams(urlParams.get('order_id'), urlParams.get('selectedOpt'));
  }

  async sendParams(orderId, selectedOpt) {
    console.log(orderId, selectedOpt);
    const response = await fetch('https://backend.paintyourlife.com/index.php?r=site/GooliAPIOrder', {
      contentType: 'application/json',
      method: 'POST',
      body: JSON.stringify({
        "action": "CustFeedback",
        "key": "lHkPYL_GooliIrfxmfWsKsmi2ix_*pylMbmUDeAi9g",
        "orderNo": String(orderId),
        "date": new Date().toISOString(),
        "Option": String(selectedOpt)
      })
    });

    if (!response.ok) {
      console.error('Failed to send the happy data to the server');
      return
    }

    console.log('Successfully sent the happy data to the server', response);
    // Send the data to the server
    // Then display the popup
    this.showPopup(selectedOpt < 3);
  }

  showPopup(happy = true) {
    if (this.popup) {
      if (happy) {
        this.happyContent.hidden = false;
        this.notHappyContent.hidden = true;
      } else {
        this.happyContent.hidden = true;
        this.notHappyContent.hidden = false;
      }

      this.popup.hidden = false;
    }
  }

  closePopup() {
    if (this.popup) {
      this.popup.hidden = true;
    }
  }
}

customElements.define('happy-email-popup', HappyEmailPopup);